import React from 'react';
import { Checkbox, Input, Popup } from 'semantic-ui-react';
import ClearableInput from '../../components/Input/ClearableInput';
import { FILTER_ANY_VALUE, FILTER_EMPTY_VALUE } from '../utils';
import './textCustom.scss';

const TextCustomFilter = ({ filter, column, setFilter, type }) => {
    const rawValue = (filter || {}).value || '';
    const isAny = rawValue === FILTER_ANY_VALUE;
    const isEmpty = rawValue === FILTER_EMPTY_VALUE;
    const isSpecial = isAny || isEmpty;
    const textValue = isSpecial ? '' : rawValue;
    const displayValue = isAny
        ? 'Любое'
        : (isEmpty ? 'Пустое' : textValue);

    const changeTextFilter = (v) => {
        setFilter({
            fieldName: column.fieldName,
            operation: 'contains',
            value: v ? v : null
        });
    };

    const changeSpecialFilter = (specialValue, checked) => {
        if (checked) {
            setFilter({
                fieldName: column.fieldName,
                operation: 'contains',
                value: specialValue
            });
            return;
        }

        setFilter({
            fieldName: column.fieldName,
            operation: 'contains',
            value: null
        });
    };

    const style = {
        border: '1px solid #135CA9',
        padding: '8px',
        borderRadius: '4px'
    };

    return (
        <Popup
            style={style}
            on="click"
            basic
            position="bottom left"
            pinned
            trigger={
                <ClearableInput
                    readOnly
                    icon={!displayValue && 'search'}
                    withSort={!column.disableSort}
                    sizer={false}
                    compact
                    placeholder={column.title}
                    value={displayValue}
                    onChange={(e, { value }) => changeTextFilter(value)}
                />
            }
        >
            <div className="text-custom-filter">
                <Input
                    type={type}
                    autoFocus
                    style={{ width: '250px' }}
                    icon="search"
                    iconPosition="left"
                    placeholder="Введите данные для поиска"
                    value={textValue}
                    onChange={(e, { value }) => changeTextFilter(value)}
                />
                <div className="text-custom-filter__flags">
{/*                     <Checkbox
                        className="text-custom-filter__flag"
                        label="Пустое"
                        checked={isEmpty}
                        onChange={(e, { checked }) => changeSpecialFilter(FILTER_EMPTY_VALUE, !!checked)}
                    /> */}
                    <Checkbox
                        className="text-custom-filter__flag"
                        label="Все заполненные"
                        checked={isAny}
                        onChange={(e, { checked }) => changeSpecialFilter(FILTER_ANY_VALUE, !!checked)}
                    />
                </div>
            </div>
        </Popup>
    );
};

export default TextCustomFilter;



// WEBPACK FOOTER //
// ./App/grids/filters/textCustom.jsx